// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"112":"6696c445","668":"6684da05","751":"246ed3d3","791":"ad3e4f5c","795":"472893a1"}[chunkId] + ".css";
};